import { gql } from '@apollo/client';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
/**
 * @fragment SaleItemListFragment
 * @since 1.0.0
 */
export const SaleItemListFragment = gql `
  fragment SaleItemListFragment on SaleItem {
    id
    sku
    price
    title
    summary
    infos
    configuration
    deletedAt

    fieldValues {
      value
      field {
        id
        name
        title
        infos
        promote
        options
      }
    }

    image {
      ...SaleItemImageFragment
    }

    translations {
      id
      title
      summary
      infos
      createdAt
      updatedAt

      language {
        id
        code
      }
    }

    variants {
      id
      sku
      price
      active
      values {
        id
        value
        field {
          id
          name
          title
          infos
          options
        }
      }
      fieldValues {
        id
        value
        field {
          id
          name
          title
          infos
          options
        }
      }
    }

    packages {
      included
      package {
        price
      }
    }

    options {
      included
      price
      quantity
    }
  }

  ${SaleItemImageFragment}
`;
